import store from '../../store'
import {
    AUTH_SET_BUSY,
    AUTH_SET_ERROR,
    AUTH_SET_USER,
} from '../auth'

/**
 * Set uth busy
 *
 * @param {boolean} busy
 * @return {{busy: *, type: string}}
 */
export const setAuthBusy = busy => (
    store.dispatch({
        type: AUTH_SET_BUSY,
        busy,
    })
)

/**
 * Set user into store
 *
 * @param {object} user
 * @return {{type: string, user: *}}
 */
export const setAuthUser = user => (
    store.dispatch({
        type: AUTH_SET_USER,
        user,
    })
)

/**
 * Set auth error
 *
 * @param {string} error
 * @return {{type: string, error: *}}
 */
export const setAuthError = error => (
    store.dispatch({
        type: AUTH_SET_ERROR,
        error,
    })
)
